import Forms from "./modules/Forms";
import Navigation from "./modules/Navigation";

/* Site Controller
 * =========================
 * This controller is loaded on every page. For any activity that needs to execute on all
 * page please implement here.
 */

/* global ga */

export default class SiteController {
  constructor(options) {
    this.options = options;
    console.log("SITE CONTROLLER");

    $.ajax(`/recipe/date/set/${new Date().getTimezoneOffset() / 60}`);

    // init the site navigation
    this.navigation = new Navigation(options);

    // footer subscribe form
    this.forms = new Forms(this.options);

    $("#nl-subscribe").click((e) => {
      this.validateSubscribeForm(e);
    });

    // show a11y menu on tab focus
    $(".a11y__skipMenu>a").focus(() => {
      console.log("HERE!!!");
      $(".a11y__skipMenu").css("top", "0px");
    });

    $(".a11y__skipMenu>a").blur(() => {
      $(".a11y__skipMenu").css("top", "");
    });

    // add the non-hover stats for product and recipe promos when required
    const isTouchDevice = "ontouchstart" in document.documentElement;

    if ($(".cmpnt__promo--lrg").length > 0 && isTouchDevice) {
      $(".cmpnt__promo--lrg").addClass("is-active");
    }

    if ($(".cmpnt__recipePromo--lrg").length > 0 && isTouchDevice) {
      $(".cmpnt__recipePromo--lrg").addClass("is-active");
    }
  }

  validateSubscribeForm(e) {
    let hasError = false;

    if (this.forms.validateEmail($("#nl-email").val())) {
      $("#nl-email").parent().removeClass("has-error");
    } else {
      $("#nl-email").parent().addClass("has-error");
      hasError = true;
    }

    // if ( this.forms.validateEmail( $('#nl-name').val() ) ) {
    //   $('#nl-name').parent().removeClass('has-error');
    // } else {
    //   $('#nl-name').parent().addClass('has-error');
    //   hasError = true;
    // }
    //
    //
    //
    // if ( this.forms.validateEmail( $('#nl-pc').val() ) ) {
    //   $('#nl-pc').parent().removeClass('has-error');
    // } else {
    //   $('#nl-pc').parent().addClass('has-error');
    //   hasError = true;
    // }

    if (!hasError) {
      let lang = "en";
      if (document.getElementsByTagName("HTML")[0].lang === "fr") {
        lang = "fr";
      }
      console.log("DO API!");
      /*
      if( $('body').hasClass('en') ) {
        $('form#signupform').attr('action','/en/signup');
      } else{
        $('form#signupform').attr('action','/fr/signup');
      }
      $('form#signupform').submit();
      */

      // $('#nl-subscribe').off('click');
      // $('#nl-subscribe').css('opacity', 0.2);
      e.preventDefault();
      $.ajax("/" + lang + "/signup/", {
        method: "POST",
        cache: false,
        data: {
          csrfmiddlewaretoken: $("input[name='csrfmiddlewaretoken']").val(),
          first_name: $("#nl-firstname").val(),
          last_name: $("#nl-lastname").val(),
          name: $("#nl-name").val(),
          user_email: $("#nl-email").val(),
          postal_code: $("#nl-pc").val(),
        },
      }).done((data) => {
        console.log("API call!");
        console.log(data);
        if (data.status === "success") {
          console.log("setting success state");
          $("#signupform").addClass("is-complete");
          $("#ftr-newsletter-signup-success").addClass("is-active");

          const url = `/${lang}/signup/`;
          const eventcategory = `Newsletter Signup - ${lang}`;

          ga("send", "event", eventcategory, "Newsletter Signup", url, {
            nonInteraction: true,
          });

          this.resetContactForm();
        } else if (data.status === "already") {
          console.log("setting success state");
          $("#signupform").addClass("is-complete");
          $("#ftr-newsletter-signup-already").addClass("is-active");

          const url = `/${lang}/signup/`;

          this.resetContactForm();
        } else {
          console.log("validation error");
          console.log(data.errors);
          // remove all errors in form
          for (const field of data.errors) {
            const elem = $(`input[name='${field}']`);
            elem.parent().addClass("has-error");
          }
        }
      });
    } else {
      e.preventDefault();
    }
  }

  resetContactForm() {
    setTimeout(() => {
      $('#signupform input[type="text"]').val("");
      $("#nl-subscribe").blur();
      $("#signupform .form-formItem").removeClass("has-content");

      $("#signupform").removeClass("is-complete");
      $(".ftrContact__success").removeClass("is-active");
    }, 10000);
  }
}



// WEBPACK FOOTER //
// ./js/controllers/SiteController.js